export default __webpack_public_path__ + "static/B0283-0cf3e3529d5e0a5f1eb2469a3907168c.png";